import * as api from '../api.js';
import { SUB_STATUS } from '#constants';

const SUB_ACTION_LABELS = {
  cancel: 'cancel',
  pause: 'pause',
  resume: 'resume',
  activate: 'update',
};

export const updateSubStatus = async (
  set,
  get,
  { status, _id, period, paymentId, customPayment }
) => {
  const action = SUB_ACTION_LABELS[status] || 'update';
  const { success, failure } = await api.updateSubStatus({
    subscription: { status, _id },
    period,
    paymentId,
    customPayment,
  });
  if (failure) {
    get().setToast({
      title: `Couldn't ${action} your subscription`,
      description:
        failure?.message || 'Please reach out to us through chat and we will sort it out.',
      status: 'error',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
    // Still refresh so the UI reflects the true current status.
    await get().getSub();
    return { failure };
  }
  // refetch sub data
  return get().getSub();
};

export const getSub = async (set, get) => {
  const { success, failure } = await api.getSub();

  if (failure) {
    // get().setToast({
    //   title: "Can't fetch subscriptions",
    //   description: failure?.message,
    //   status: 'error',
    //   duration: 2000,
    //   isClosable: true,
    //   position: 'top',
    // });
    set({ subs: [], sub: {} }, false, { type: 'getSub' });
    return;
  }

  const { subs } = success;
  // Allow tracker creation for all of the following statuses
  const sub = subs.find(
    (s) =>
      s.status === SUB_STATUS.ACTIVE ||
      s.status === SUB_STATUS.PAUSE_REQUESTED ||
      s.status === SUB_STATUS.RESUME_REQUESTED ||
      s.status === SUB_STATUS.CANCEL_REQUESTED
  );
  set({ subs, sub }, false, { type: 'getSub' });
  return sub;
};

export const getUpgradePreview = async (set, get, { subscriptionId }) => {
  const { success, failure } = await api.getUpgradePreview({ subscriptionId });
  if (failure) {
    get().setToast({
      title: "Couldn't load upgrade details",
      description:
        failure?.message ||
        'Please reach out to us through chat and we will sort it out.',
      status: 'error',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
    return { failure };
  }
  return { success };
};

export const upgradeSubscription = async (set, get, { subscriptionId }) => {
  const { success, failure } = await api.upgradeSubscription({ subscriptionId });
  if (failure) {
    get().setToast({
      title: "Couldn't upgrade your subscription",
      description:
        failure?.message ||
        'Please reach out to us through chat and we will sort it out.',
      status: 'error',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
    return { failure };
  }
  get().setToast({
    title: 'Upgraded to yearly plan',
    description: `You're all set. Your plan renews on ${new Date(
      success.upgrade.renewalDate
    ).toDateString()}.`,
    status: 'success',
    duration: 5000,
    isClosable: true,
    position: 'top',
  });
  return get().getSub();
};
